/* Local contact measurement. Payloads contain only allowlisted categories and pathname. */
(function () {
  'use strict';
  if (window.__agLocalLeadsLoaded) return;
  window.__agLocalLeadsLoaded = true;
  var pendingKey = 'ag_local_pending_v1';
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (e) { return false; }
  }
  function publish(name, method, placement) {
    if (!allowed() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
    if (['phone', 'whatsapp', 'directions', 'contact_form', 'newsletter', 'waitlist'].indexOf(method) < 0 ||
      ['contact_page', 'footer', 'welcome_popup', 'shipping_section', 'about_section', 'subscriptions_page', 'other'].indexOf(placement) < 0) return false;
    try {
      var pathname = window.location.pathname;
      if (pathname.length > 200 || /[?#@\s]/.test(decodeURIComponent(pathname))) pathname = '/';
      var result = window.Shopify.analytics.publish(name, { method: method, placement: placement, pathname: pathname });
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (e) { return false; }
  }
  function placement(node) {
    if (node.closest('.ct-page')) return 'contact_page';
    if (node.closest('.fa')) return 'footer';
    if (node.closest('[data-agpop]')) return 'welcome_popup';
    if (node.closest('.ve')) return 'shipping_section';
    if (node.closest('.sn-page')) return 'about_section';
    if (node.closest('.ag-subs')) return 'subscriptions_page';
    return 'other';
  }
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a') : null;
    if (!link) return;
    var method = link.matches('a[href^="tel:"]') ? 'phone' :
      link.matches('a[href*="wa.me/"], a[href*="api.whatsapp.com/"]') ? 'whatsapp' :
      link.matches('a[href*="google.com/maps"], a[href*="maps.app.goo.gl/"]') ? 'directions' : null;
    if (method) publish('ag_local_contact_click', method, placement(link));
  }, true);
  document.addEventListener('submit', function (event) {
    if (!allowed()) return;
    var form = event.target;
    var kind = form.matches('.ct-form-wrap form') ? 'contact' :
      form.matches('.fa__news-form, .agpop__form') ? 'newsletter' :
        form.matches('.ag-subs__waitlist-form') ? 'waitlist' : null;
    if (!kind) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ kind: kind, placement: placement(form), at: Date.now() })); }
    catch (e) { /* Storage can be unavailable; never interrupt the form. */ }
  }, true);
  function confirmedSubmission() {
    if (!allowed()) return;
    try {
      var pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending) return;
      if (Date.now() - pending.at > 1800000) { sessionStorage.removeItem(pendingKey); return; }
      var selector = pending.kind === 'contact' ? '.ct-form__success' :
        pending.kind === 'waitlist' ? '.ag-subs__success' :
        pending.placement === 'footer' ? '.fa__news-msg--ok' :
        pending.placement === 'welcome_popup' ? '.agpop__ok' : null;
      if (!selector || !document.querySelector(selector)) return;
      var name = pending.kind === 'contact' ? 'ag_local_lead_submitted' :
        pending.kind === 'waitlist' ? 'ag_local_waitlist_signup' : 'ag_local_newsletter_signup';
      var method = pending.kind === 'contact' ? 'contact_form' : pending.kind === 'waitlist' ? 'waitlist' : 'newsletter';
      if (publish(name, method, pending.placement)) sessionStorage.removeItem(pendingKey);
    } catch (e) { /* Invalid or blocked storage must never affect the storefront. */ }
  }
  // MK-B4: ag_popup_view / ag_popup_submit. Solo si la ventana los pide (data-agpop-eventos="1",
  // apagado hasta que la política de privacidad recoja la segmentación, DT-23) y con consentimiento
  // de analítica. Sin correo ni datos personales: interés de una lista cerrada y ruta.
  var intereses = ['interes-legumbres-arroces', 'interes-especias', 'interes-desayuno', 'interes-reposteria'];
  document.addEventListener('ag:popup', function (event) {
    var d = (event && event.detail) || {};
    var nodo = document.querySelector('[data-agpop]');
    if (!nodo || nodo.getAttribute('data-agpop-eventos') !== '1') return;
    if (!allowed() || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var name = d.accion === 'view' ? 'ag_popup_view' : d.accion === 'submit' ? 'ag_popup_submit' : null;
    if (!name) return;
    try {
      var pathname = window.location.pathname;
      if (pathname.length > 200 || /[?#@\s]/.test(decodeURIComponent(pathname))) pathname = '/';
      var payload = { placement: 'welcome_popup', pathname: pathname };
      if (name === 'ag_popup_submit') payload.interest = intereses.indexOf(d.interes) > -1 ? d.interes : 'none';
      var result = window.Shopify.analytics.publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (e) { /* la medición nunca interrumpe la tienda */ }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', confirmedSubmission, { once: true });
  else confirmedSubmission();
  document.addEventListener('visitorConsentCollected', confirmedSubmission);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', confirmedSubmission);
}());
